<p8-page-block>
  <div class="p8-page-block-header">
    <span class="p8-secondary">Image</span>
  </div>
  <div class="p8-page-block-content" fxLayout="row">
    <button mat-raised-button (click)="openMedias()" *ngIf="! hasImage()">CHOISIR IMAGE</button>

    <div class="p8-bdc_edit-image__image-container" *ngIf="hasImage()">
      <img [src]="calculateUrl(block)" [alt]="file?.name">
    </div>
  </div>
</p8-page-block>
